import { useState } from 'react';
import { Button } from 'react-bootstrap';

import { window } from '../../../globals';
import { getProjectBaseURLFromParams } from '../../../utils';
import Icon, { icons } from '../../generic/Icon';
import RouterLink from '../../generic/Link/RouterLink';
import ModalShareProject from '../../modals/ModalShareProject';
import type { ProjectDashboardProject, ProjectDashboardRevision, RevisionRouteParams } from '../projectDashboardTypes';

type OwnProps = {
  project: ProjectDashboardProject;
  revision: ProjectDashboardRevision;
  params: RevisionRouteParams;
};

const ProjectChecksPassedPanel = ({
  params,
  revision,
  project,
}: OwnProps) => {
  const [isShowingShareModal, showShareModal] = useState<boolean>(false);

  return (
    <div className="text-center card card-success noborder margin-top">
      <div style={{ fontSize: '65px', padding: '10px 0px 20px 0px' }}>
        <Icon icon={icons.review} />
      </div>
      <p className="subtitle">
        FOSSA ran license checks across <b>{revision.data.dependency_count}</b> dependencies.
        <div>No issues were found.</div>
      </p>
      <span style={{ padding: '0px 5px' }}>
        <RouterLink
          to={`${getProjectBaseURLFromParams(params)}/reports`}
        >
          <Icon icon={icons.addToProject} /> Generate Report
        </RouterLink>
      </span>
      {!window.on_prem &&
        <span>
          &nbsp;&nbsp;
          <Button
            bsStyle="success"
            onClick={() => showShareModal(true)}
            className="clickable animated tada">
            <Icon icon={icons.share} /> Share
          </Button>
        </span>}
      <ModalShareProject
        show={isShowingShareModal}
        locator={project.data.locator}
        onHide={() => showShareModal(false)} />
    </div>);
};

export default ProjectChecksPassedPanel;
